import './ContentPage.scss';
import Component from './ContentPage';
export default Component;